// extracted by mini-css-extract-plugin
export default {"wrap":"list_wrap__ZLnq3"};